import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './registerServiceWorker'

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = true; 

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
